import { 
  Stack, 
  TextField, 
  Typography, 
  Box, 
  Button, 
  Card, 
  CardContent,
} from "@mui/material";
import { QuestionMarkTooltip } from "../../../common/tooltip/question-mark-tooltip";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../toast/toast-service";
import { SUGGEST_NEW_COURSE } from "../../../layout/courseNav/search-course-nav/suggestNewCourseQueries";
import { useMutation } from "@apollo/client";

export const SuggestNewCourseBox = ({ selectedUniversityName }) => {
  const [newCourseTitel, setNewCourseTitel] = useState("");

  const [suggestNewCourse] = useMutation(SUGGEST_NEW_COURSE, {
    onCompleted: () => {
      setNewCourseTitel("");
      showSuccessToast(
        <FormattedMessage
          id={
            "courses-nav.search-course.suggest-new-course.send-button.success-toast"
          }
        />,
        10000
      );
    },
    onError: (error) => {
      console.error(error);
      showErrorToast(error.message);
    },
    variables: {
      title: newCourseTitel,
      university: selectedUniversityName,
    },
  });

  return (
    <Box sx={{ 
      p: { xs: 2, sm: 3 },
      height: '100%',
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Card sx={{ mb: 3, boxShadow: 1 }}>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
            <Typography variant="body1" color="text.primary">
              <FormattedMessage
                id={"courses-nav.search-course.suggest-new-course.motivation-text"}
              />
            </Typography>
            <QuestionMarkTooltip tooltipId="courses-nav.search-course.suggest-new-course.motivation-text.tooltip" />
          </Stack>
        </CardContent>
      </Card>

      <Card sx={{ flex: 1, boxShadow: 1 }}>
        <CardContent sx={{ 
          p: { xs: 2, sm: 3 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Stack spacing={3} sx={{ flex: 1 }}>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <FormattedMessage
                  id={
                    "courses-nav.search-course.suggest-new-course.textbox.description-text"
                  }
                />
              </Typography>
              <TextField
                multiline
                label={
                  <FormattedMessage id="courses-nav.search-course.suggest-new-course.textbox.placeholder" />
                }
                rows={4}
                fullWidth
                value={newCourseTitel}
                onChange={(event) => {
                  setNewCourseTitel(event.target.value);
                }}
                sx={{
                  mt: 2,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(0,0,0,0.23)',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  },
                }}
              />
            </Box>

            <Box sx={{ mt: 'auto', pt: 2 }}>
              <Button
                variant="contained"
                disabled={newCourseTitel.length === 0}
                onClick={suggestNewCourse}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  py: 1.5,
                  px: 3,
                }}
              >
                <FormattedMessage
                  id={"courses-nav.search-course.suggest-new-course.send-button"}
                />
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

